"use client";

import * as React from "react";
import styled from "styled-components";

import { SVGIcon } from "../SVGIcon";

export type Direction = "up" | "down" | "left" | "right" | "upAndRight";

const DirectionalIcon = styled(SVGIcon)<{ direction: Direction }>`
  transform: rotateZ(
    ${({ direction }) => {
      switch (direction) {
        case "right":
          return "0deg";
        case "down":
          return "90deg";
        case "left":
          return "180deg";
        case "upAndRight":
          return "315deg";
        case "up":
        default:
          return "270deg";
      }
    }}
  );
`;

// Wrapping for better alignment with rotated versions
const RotationalContainer = styled.div`
  overflow: hidden;
  display: flex;
`;

export const Arrow = React.memo(({ direction, ref, ...props }: SVGIcon.IProps & { direction: Direction } & React.RefAttributes<SVGElement>) => {
  return (
    <RotationalContainer>
      <DirectionalIcon
        direction={direction}
        viewBox="0 0 24 24"
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          d="M0.856934 12H23.1426"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.1426 18L23.1426 12L17.1426 6"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </DirectionalIcon>
    </RotationalContainer>
  );
});

if (process.env.NODE_ENV !== "production") {
  Arrow.displayName = `ArrowIcon`;
}
